import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import getQueryKey from "../get-query-key";
import patchCart from "../api-calls/patch-cart";
import getCartReviewsQueryKey from "../../../cart_reviews/v2/get-query-key";
import getPartnerCartReviewsQueryKey from "../../../partner_cart_reviews/v1/get-query-key";
import getPartnerCartReviewsV2QueryKey from "../../../partner_cart_reviews/v2/get-query-key";

/**
 * MAGIC_VISITOR_ID is used for passing to a patch call to carts v2 in order to have
 * backend validate and fix the cart when we don't know how to fix it on the front-end.
 * We use it to create a validateOnly flag for the mergeCarts function.
 */
export var MAGIC_VISITOR_ID = '00000000-0000-0000-0000-000000000000';

/**
 * mergeCarts - Merges guest cart with member cart when user logs in
 *
 * @param {object} params - named parameters
 * @param {boolean} [params.validateOnly=false] - If true, uses magic visitor ID to force server validation
 * @param {object} [params.fetchOptions] - Additional fetch options to pass through
 * @returns {Promise} fetch promise
 */
export var mergeCarts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref2,
      _ref2$validateOnly,
      validateOnly,
      fetchOptions,
      visitData,
      finalVisitorId,
      actions,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly, fetchOptions = _ref2.fetchOptions;
          _context.next = 1;
          return window.webShellClient.identity.getVisitData();
        case 1:
          visitData = _context.sent;
          finalVisitorId = validateOnly ? MAGIC_VISITOR_ID : visitData.visitorId;
          actions = [{
            op: 'merge',
            path: '/',
            value: {
              visitorId: finalVisitorId
            }
          }];
          return _context.abrupt("return", patchCart({
            actions: actions,
            fetchOptions: fetchOptions
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function mergeCarts() {
    return _ref.apply(this, arguments);
  };
}();

/**
 * getMergeCartsOptions - Returns React Query mutation options for merging carts
 *
 * @param {object} params - named parameters
 * @param {object} params.queryClient - React Query client instance
 * @param {boolean} [params.validateOnly=false] - If true, uses magic visitor ID to force server validation
 * @param {object} [params.fetchOptions] - Additional fetch options
 * @returns {object} React Query mutation options
 */
var getMergeCartsOptions = function getMergeCartsOptions() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    queryClient = _ref3.queryClient,
    _ref3$validateOnly = _ref3.validateOnly,
    validateOnly = _ref3$validateOnly === void 0 ? false : _ref3$validateOnly,
    fetchOptions = _ref3.fetchOptions;
  return {
    mutationKey: [].concat(_toConsumableArray(getQueryKey()), ['merge']),
    mutationFn: function mutationFn() {
      return mergeCarts({
        validateOnly: validateOnly,
        fetchOptions: fetchOptions
      });
    },
    onMutate: function () {
      var _onMutate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", {
                meta: {
                  dispatchCartUpdated: true,
                  dispatchCartCountUpdated: true
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function onMutate() {
        return _onMutate.apply(this, arguments);
      }
      return onMutate;
    }(),
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var reviewQueryKeys;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (data) {
                queryClient.setQueryData(getQueryKey(), data);
              }
              reviewQueryKeys = [getCartReviewsQueryKey(), getPartnerCartReviewsQueryKey(), getPartnerCartReviewsV2QueryKey()]; // Cancel in-flight cart reviews fetches that may be using stale pre-merge cart data,
              // so invalidateQueries triggers a fresh fetch with the updated merged cart.
              // Wrapped in try-catch because queries may already be aborted if their enabled
              // condition toggled (e.g. marketplace support check resolved after mount).
              _context3.next = 1;
              return Promise.allSettled(reviewQueryKeys.map(function (queryKey) {
                return queryClient.cancelQueries({
                  queryKey: queryKey
                })["catch"](function () {});
              }));
            case 1:
              _context3.next = 2;
              return Promise.allSettled(reviewQueryKeys.map(function (queryKey) {
                return queryClient.invalidateQueries({
                  queryKey: queryKey
                });
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function onSuccess(_x) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  };
};
export default getMergeCartsOptions;